// src/pages/Admin/Users/components/RoleBadge.jsx
import React from "react";

const tones = {
  red: "bg-red-100 text-red-700",
  green: "bg-green-100 text-green-700",
  blue: "bg-blue-100 text-blue-700",
  indigo: "bg-indigo-100 text-indigo-700",
  violet: "bg-violet-100 text-violet-700",
  orange: "bg-orange-100 text-orange-700",
  gray: "bg-slate-100 text-slate-700",
};

export function RoleBadge({ children, tone = "gray" }) {
  return (
    <span
      className={`px-2 py-0.5 rounded text-xs ${
        tones[tone] || tones.gray
      }`}
    >
      {children}
    </span>
  );
}
